const topbar = {
    docs: 'Documentos',
    help: 'Ayuda',
};
export default Object.freeze(topbar);
